import appConstants from '../../../../../../constants';
import computeClassName from '../../../../../../utils/computeClassName';
import PartnerNameRolesLevelsAndExpertises from "../../../../Partner/NameRolesLevelsAndExpertises";

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

export default function PartnerProfileExpertises(
  {
    partnerName,
    partnerRolesAndLevels,
    partnerExpertises,
    className = ''
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);

  return (
    <section id="expertises" className={computedClassName}>
      <PartnerNameRolesLevelsAndExpertises className="px-10 xs:px-0 xs:mx-auto xs:w-7/12"
                                           name={partnerName}
                                           rolesAndLevels={partnerRolesAndLevels}
                                           expertises={partnerExpertises}/>

    </section>
  );
}
